import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { useParams } from 'react-router-dom';
import { toJS } from 'mobx';
import { ActionModal, OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import DownloadFilesTable from 'components/common/download-files/DownloadFilesTable';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { buildPdfLink } from 'global/services-helpers/pdfService';
import TableInfoBar, { TotalFilesLabel } from 'components/common/download-files/TableInfoBar';
import ZipFileSection from 'components/common/download-files/ZipFileSection';
import { downloadFileByLink } from 'global/utils/downloadFileByLink';
import { getZipAvailabilityNote } from 'global/utils/fileAvailability';

const AdditionalOutputsContent: React.FC = observer(() => {
  const {
    additionalOutputsStore: {
      outputPDFs,
      outputZip,
      loading,
      isWarningModalOpen,
      getInitialData,
      resetFiles,
      downloadFinalZip,
      updateModalShowStatus,
    },
  } = useRootStore();

  const { periodId } = useParams<{ periodId: string }>();

  useEffect(() => {
    void getInitialData(periodId);
    return resetFiles;
  }, []);

  const outputPDFList = outputPDFs.map((dateObj) => toJS(dateObj)).slice();

  const downloadPdfFile = (id: string, name: string): void => {
    const downloadLink = buildPdfLink(id);
    downloadFileByLink(name, downloadLink);
  };

  return (
    <>
      {loading ? (
        <OverlaySpinner display={loading} overlay="none" />
      ) : (
        <>
          {outputZip?.id && (
            <>
              <TableInfoBar title="Final ZIP" rightContent={getZipAvailabilityNote(outputZip)} />
              <ZipFileSection file={outputZip} loading={loading} onDownload={downloadFinalZip} />
            </>
          )}

          <TableInfoBar title="Member ID Cards" rightContent={<TotalFilesLabel filesAmount={outputPDFList.length} />} />
          <DownloadFilesTable loading={loading} filesList={outputPDFList} onDownload={downloadPdfFile} />

          <ActionModal
            show={isWarningModalOpen}
            onClose={(): void => {
              updateModalShowStatus(false);
            }}
            title={
              <span>
                Your member ID cards are currently being processed. <br /> Please check back in 48 hours.
              </span>
            }
            modalType={ModalType.NOTIFICATION}
          />
        </>
      )}
    </>
  );
});

export default AdditionalOutputsContent;
